module.exports = __webpack_public_path__ + "static/img/he4.d748acb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/he4.png
// module id = 0aOa
// module chunks = 1